import { ChangeDetectionStrategy, Component, Input, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BlockMargin } from '@service/article/article.service';
import { MarginService } from '../margin.service';

interface TextSectionInterface
{
  paragraphs: string;
}

@Component({
    selector: 'app-text-section',
    templateUrl: './text-section.component.html',
    styleUrls: ['./text-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TextSectionComponent implements OnInit
{
  @Input() section: TextSectionInterface;
  @Input() margin: BlockMargin;

  public descriptionHtml

  constructor(public changeDet: ChangeDetectorRef, public sanitizer: DomSanitizer, public marginService: MarginService) { }

  ngOnInit(): void
  {
    this.descriptionHtml = this.sanitizer.bypassSecurityTrustHtml(this.section.paragraphs);
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize($event): void
  {
    this.changeDet.detectChanges();

  }
}
